import { Injectable } from '@angular/core';

import { ApiService} from '../../../core/service/api.service';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {Subject} from "rxjs/Subject";
import {HttpParams} from '@angular/common/http';

@Injectable()
export class FileDownloadService {

    private fileDownloadSubject = new Subject<string>();

    constructor(private api: ApiService) {
    }

    downloadFile(pk: number, filename: string, source: string): Observable<ArrayBuffer> {
        const options = this.api.createOptions({});
        return this.api.getHttp().get(this.api.createUrl('file/' + pk + '/download'), {
            'headers' : options['headers'],
            'responseType' : 'arraybuffer',
            'params' : {
              'ext_source' : source
            }
        });
    }

    getSubject(): Subject<string> {
        return this.fileDownloadSubject;
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/shared/components/file_download/file_download.service.ts